// extracted by mini-css-extract-plugin
module.exports =  {"flex-gap":"dAJgpGx","flexGap":"dAJgpGx"};